// import { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { AiOutlineApartment, AiOutlineUnorderedList } from "react-icons/ai";
// import css from "./catalog.module.css";
// import { fetchProducts, fetchProductsAll } from "../../function/productsSlice";
// import { db } from "../../firebase";
// import { getDocs, collection } from "firebase/firestore";
// import Filter from "./filter";
// import CatalogProductComponent from "../standartComponent/productComponent/catalogProductComponent";
// import SatalogProductComponentsSmall from "../standartComponent/productComponent/catalogProductComponentsSmall";
// import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
// import DiscountAndAction from "./discountAndAction";
// import ViewProductCatalog from "./viewProductCatalog";
// import ListButtonCount from "./listButtonCount";

// export default function Catalog({
//   setVisitedProducts,
//   visitedProducts,
//   productsAll,
//   setCartCounterC,
//   setLikeCounterC,
// }) {
//   const dispatch = useDispatch();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [changeVisible, setChangeVisible] = useState(() => {
//     return localStorage.getItem("catalogView") === "list";
//   });

//   const productsPerPage = 10;
//   const filters = useSelector((state) => state.filters);
//   const searchResults = useSelector((state) => state.products.searchResults);
//   const [products, setProducts] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       // ====== 0) БАЗОВИЙ СПИСОК (пошук/фільтри/всі) ======
//       let baseProducts = [];
//       if (searchResults.length > 0) {
//         baseProducts = searchResults;
//       } else if (filters.length === 0) {
//         baseProducts = await dispatch(fetchProductsAll()).unwrap();
//       } else {
//         baseProducts = await dispatch(fetchProducts(filters)).unwrap();
//       }

//       // ====== 1) АКЦІЇ (actions) ======
//       const snapshotActions = await getDocs(collection(db, "actions"));
//       const actions = snapshotActions.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const now = new Date();

//       // Підтягнемо всі продукти з БД (для правил підбору)
//       const snapshotProducts = await getDocs(collection(db, "product"));
//       const allProducts = snapshotProducts.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const actionProducts = allProducts.filter((product) => {
//         return actions.some((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = action.endDate ? new Date(action.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const matchProduct = action.appliesTo?.products?.includes(
//             product.uid
//           );

//           const productSeries = Array.isArray(product.seria)
//             ? product.seria
//             : typeof product.seria === "string" && product.seria !== ""
//             ? [product.seria]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             action.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(product.textAutor)
//             ? product.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof product.textAutor === "string" && product.textAutor !== ""
//             ? [product.textAutor.split(" ")[0].trim()]
//             : [];

//           const actionAuthors = Array.isArray(action.appliesTo?.authors)
//             ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             actionAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });
//       });

//       const actionProductsWithDiscount = actionProducts.map((product) => {
//         const matchedAction = actions.find((action) => {
//           const start = action.startDate ? new Date(action.startDate) : null;
//           const end = action.endDate ? new Date(action.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const matchProduct = action.appliesTo?.products?.includes(
//             product.uid
//           );

//           const productSeries = Array.isArray(product.seria)
//             ? product.seria
//             : typeof product.seria === "string" && product.seria !== ""
//             ? [product.seria]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             action.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(product.textAutor)
//             ? product.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof product.textAutor === "string" && product.textAutor !== ""
//             ? [product.textAutor.split(" ")[0].trim()]
//             : [];

//           const actionAuthors = Array.isArray(action.appliesTo?.authors)
//             ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             actionAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });

//         if (matchedAction) {
//           return {
//             ...product,
//             actionDiscountPercent: matchedAction.discountPercent,
//           };
//         }
//         return product;
//       });

//       // ====== 2) РОЗПРОДАЖІ (sales) ======
//       const snapshotSales = await getDocs(collection(db, "sales"));
//       const sales = snapshotSales.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       const saleMatchedProducts = allProducts.filter((product) => {
//         return sales.some((sale) => {
//           const start = sale.startDate ? new Date(sale.startDate) : null;
//           const end = sale.endDate ? new Date(sale.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const matchProduct = sale.appliesTo?.products?.includes(product.uid);

//           // уразі, якщо в товарах іноді series пишеться як seria
//           const productSeries = Array.isArray(product.seria)
//             ? product.seria
//             : typeof product.seria === "string" && product.seria !== ""
//             ? [product.seria]
//             : Array.isArray(product.series)
//             ? product.series
//             : typeof product.series === "string" && product.series !== ""
//             ? [product.series]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             sale.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(product.textAutor)
//             ? product.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof product.textAutor === "string" && product.textAutor !== ""
//             ? [product.textAutor.split(" ")[0].trim()]
//             : [];

//           const saleAuthors = Array.isArray(sale.appliesTo?.authors)
//             ? sale.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             saleAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });
//       });

//       const saleProductsWithDiscount = saleMatchedProducts.map((p) => {
//         const s = sales.find((sale) => {
//           const start = sale.startDate ? new Date(sale.startDate) : null;
//           const end = sale.endDate ? new Date(sale.endDate) : null;

//           if (end && now > end) return false;
//           if (start && now < start) return false;

//           const matchProduct = sale.appliesTo?.products?.includes(p.uid);

//           const productSeries = Array.isArray(p.seria)
//             ? p.seria
//             : typeof p.seria === "string" && p.seria !== ""
//             ? [p.seria]
//             : Array.isArray(p.series)
//             ? p.series
//             : typeof p.series === "string" && p.series !== ""
//             ? [p.series]
//             : [];

//           const matchSeries = productSeries.some((ser) =>
//             sale.appliesTo?.series?.includes(ser)
//           );

//           const productAuthors = Array.isArray(p.textAutor)
//             ? p.textAutor.map((a) => a.split(" ")[0].trim())
//             : typeof p.textAutor === "string" && p.textAutor !== ""
//             ? [p.textAutor.split(" ")[0].trim()]
//             : [];

//           const saleAuthors = Array.isArray(sale.appliesTo?.authors)
//             ? sale.appliesTo.authors.map((a) => a.split(" ")[0].trim())
//             : [];

//           const matchAuthor = productAuthors.some((a) =>
//             saleAuthors.includes(a)
//           );

//           return matchProduct || matchSeries || matchAuthor;
//         });

//         if (s) {
//           return { ...p, saleDiscountPercent: Number(s.discountPercent) || 0 };
//         }
//         return p;
//       });

//       // Мапа для швидкого підкладання знижки у будь-який список
//       const saleDiscountMap = new Map(
//         saleProductsWithDiscount
//           .filter((p) => p.saleDiscountPercent > 0)
//           .map((p) => [p.uid || p.id, p.saleDiscountPercent])
//       );

//       // ====== 3) Продукти, де поле sale=true (старий флаг для розділу "Акції")
//       const saleFlagProducts = await dispatch(
//         fetchProducts([{ field: "sale", value: "true" }])
//       ).unwrap();

//       // ====== 4) ДЕТЕКТУЄМО АКТИВНІ ФІЛЬТРИ ======
//       const hasSaleFilter = filters.some(
//         (f) => f.field === "sale" && f.value === "true"
//       );
//       const hasRozprodazFilter = filters.some(
//         (f) => f.field === "rozprodaz" && f.value === "true"
//       );

//       // ====== 5) Комбінуємо ======
//       // Починаємо з базових
//       let combined = [...baseProducts];

//       // Якщо "Акції" — додаємо товари з actions (pct) і старі "sale=true"
//       if (hasSaleFilter) {
//         combined = [
//           ...combined,
//           ...actionProductsWithDiscount.filter(
//             (ap) =>
//               !combined.some((bp) => (bp.uid || bp.id) === (ap.uid || ap.id))
//           ),
//           ...saleFlagProducts.filter(
//             (sp) =>
//               !combined.some((bp) => (bp.uid || bp.id) === (sp.uid || sp.id)) &&
//               !actionProductsWithDiscount.some(
//                 (ap) => (ap.uid || ap.id) === (sp.uid || sp.id)
//               )
//           ),
//         ];
//       }

//       // Якщо "Розпродаж" — додаємо все, що підпало під правила з колекції sales
//       if (hasRozprodazFilter) {
//         combined = [
//           ...combined,
//           ...saleProductsWithDiscount.filter(
//             (sp) =>
//               !combined.some((bp) => (bp.uid || bp.id) === (sp.uid || sp.id))
//           ),
//         ];
//       }

//       // Підкладаємо saleDiscountPercent у будь-які позиції комбінованого (щоб ціни всюди рахувались)
//       combined = combined.map((p) => {
//         const key = p.uid || p.id;
//         const pct = saleDiscountMap.get(key);
//         return pct && !Number.isNaN(pct)
//           ? { ...p, saleDiscountPercent: pct }
//           : p;
//       });

//       // ====== 6) Сорт ======
//       combined.sort((a, b) => {
//         const sortA =
//           a.sorterNumber && !isNaN(a.sorterNumber)
//             ? Number(a.sorterNumber)
//             : Infinity;
//         const sortB =
//           b.sorterNumber && !isNaN(b.sorterNumber)
//             ? Number(b.sorterNumber)
//             : Infinity;
//         return sortA - sortB;
//       });

//       setProducts(combined);
//     };

//     fetchData();
//   }, [filters, searchResults, dispatch]);

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const toggleView = () => {
//     setChangeVisible((prev) => {
//       const newView = !prev;
//       localStorage.setItem("catalogView", newView ? "list" : "grid");
//       return newView;
//     });
//   };

//   const startIndex = (currentPage - 1) * productsPerPage;
//   const endIndex = startIndex + productsPerPage;
//   const currentProducts = products.slice(startIndex, endIndex);

//   const numberOfPages = Math.ceil(products.length / productsPerPage);
//   const maxDisplayedPages = 5;
//   const firstDisplayedPages = Math.max(
//     currentPage - Math.floor(maxDisplayedPages / 2),
//     1
//   );
//   const lastDisplayedPages = Math.min(
//     firstDisplayedPages + maxDisplayedPages - 1,
//     numberOfPages
//   );

//   const pageNumbers = [];
//   for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
//     pageNumbers.push(i);
//   }

//   return (
//     <>
//       <Filter filters={filters} />

//       <div className={css.wrapCatalogChanges}>
//         <p className={css.nameFormatPere}>Змінити формат перегляду</p>
//         {changeVisible ? (
//           <AiOutlineApartment
//             className={css.catalogVisibleCss}
//             onClick={toggleView}
//           />
//         ) : (
//           <AiOutlineUnorderedList
//             className={css.catalogVisibleCss}
//             onClick={toggleView}
//           />
//         )}
//       </div>

//       {!changeVisible &&
//         currentProducts.map((el) => (
//           <CatalogProductComponent
//             visitedProducts={visitedProducts}
//             setVisitedProducts={setVisitedProducts}
//             el={el}
//             key={el.id || el.uid}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//         ))}

//       {changeVisible && currentProducts.length > 0 && (
//         <>
//           <SatalogProductComponentsSmall
//             visitedProducts={visitedProducts}
//             setVisitedProducts={setVisitedProducts}
//             el={currentProducts[0]}
//             key={currentProducts[0].id || currentProducts[0].uid}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//           <div className={css.wrapSmallProductTwoType}>
//             {currentProducts.slice(1).map((el) => (
//               <SmallProductCartTop
//                 el={el}
//                 key={el.id || el.uid}
//                 setCartCounterC={setCartCounterC}
//                 setLikeCounterC={setLikeCounterC}
//               />
//             ))}
//           </div>
//         </>
//       )}

//       <ListButtonCount
//         pageNumbers={pageNumbers}
//         handlePageClick={handlePageClick}
//         currentPage={currentPage}
//       />

//       <DiscountAndAction />
//       <ViewProductCatalog
//         products={productsAll}
//         setCartCounterC={setCartCounterC}
//         setLikeCounterC={setLikeCounterC}
//       />
//     </>
//   );
// }
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AiOutlineApartment, AiOutlineUnorderedList } from "react-icons/ai";
import css from "./catalog.module.css";
import { fetchProducts, fetchProductsAll } from "../../function/productsSlice";
import { setFilters } from "../../function/filtersSlice";
import { db } from "../../firebase";
import { getDocs, collection } from "firebase/firestore";
import Filter from "./filter";
import CatalogProductComponent from "../standartComponent/productComponent/catalogProductComponent";
import SatalogProductComponentsSmall from "../standartComponent/productComponent/catalogProductComponentsSmall";
import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
import DiscountAndAction from "./discountAndAction";
import ViewProductCatalog from "./viewProductCatalog";
import ListButtonCount from "./listButtonCount";
const RESERVED_QUERY_PARAMS = new Set([
  "page",
  "sort",
  "view",
  "q",
  "search",
  "s",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
]);

const normalizeFilterValue = (value) => {
  if (value === true) return "true";
  if (value === false) return "false";
  return String(value);
};

const getFiltersFromSearch = (search) => {
  const params = new URLSearchParams(search);
  const filtersFromUrl = [];

  params.forEach((value, field) => {
    if (!field || RESERVED_QUERY_PARAMS.has(field)) return;
    if (value === "") return;

    filtersFromUrl.push({
      field,
      value: normalizeFilterValue(value),
    });
  });

  return filtersFromUrl.filter(
    (filter, index, self) =>
      index ===
      self.findIndex(
        (item) => item.field === filter.field && item.value === filter.value,
      ),
  );
};

const getSearchFromFilters = (filters) => {
  const params = new URLSearchParams();

  filters.forEach((filter) => {
    if (!filter?.field || filter.value === undefined || filter.value === null) {
      return;
    }

    params.append(filter.field, normalizeFilterValue(filter.value));
  });

  const search = params.toString();
  return search ? `?${search}` : "";
};

const getFiltersKey = (filters) => {
  return [...filters]
    .map((filter) => `${filter.field}=${normalizeFilterValue(filter.value)}`)
    .sort()
    .join("&");
};

const areFiltersEqual = (firstFilters, secondFilters) => {
  return getFiltersKey(firstFilters) === getFiltersKey(secondFilters);
};
export default function Catalog({
  setVisitedProducts,
  visitedProducts,
  productsAll,
  setCartCounterC,
  setLikeCounterC,
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isHydratedFromUrl = useRef(false);
  const isSyncingFromUrl = useRef(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [changeVisible, setChangeVisible] = useState(() => {
    return localStorage.getItem("catalogView") === "list";
  });

  const productsPerPage = 10;
  const filters = useSelector((state) => state.filters);
  const filtersRef = useRef(filters);
  const searchResults = useSelector((state) => state.products.searchResults);
  const [products, setProducts] = useState([]);
  const [urlFiltersReady, setUrlFiltersReady] = useState(false);
  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);
  useEffect(() => {
    const filtersFromUrl = getFiltersFromSearch(location.search);

    if (!isHydratedFromUrl.current) {
      isHydratedFromUrl.current = true;

      if (
        filtersFromUrl.length > 0 &&
        !areFiltersEqual(filtersRef.current, filtersFromUrl)
      ) {
        isSyncingFromUrl.current = true;
        dispatch(setFilters(filtersFromUrl));
        setCurrentPage(1);
      }

      setUrlFiltersReady(true);
      return;
    }

    if (filtersFromUrl.length === 0) {
      return;
    }

    if (!areFiltersEqual(filtersRef.current, filtersFromUrl)) {
      isSyncingFromUrl.current = true;
      dispatch(setFilters(filtersFromUrl));
      setCurrentPage(1);
    }
  }, [location.search, dispatch]);
  useEffect(() => {
    if (!urlFiltersReady) return;

    if (isSyncingFromUrl.current) {
      isSyncingFromUrl.current = false;
      return;
    }

    const nextSearch = getSearchFromFilters(filters);

    if (location.search !== nextSearch) {
      navigate(
        {
          pathname: location.pathname,
          search: nextSearch,
        },
        { replace: true },
      );
    }

    setCurrentPage(1);
  }, [filters, location.pathname, location.search, navigate, urlFiltersReady]);
  useEffect(() => {
    if (!urlFiltersReady) return;
    const fetchData = async () => {
      // ====== 0) БАЗОВИЙ СПИСОК (пошук/фільтри/всі) ======
      let baseProducts = [];
      if (searchResults.length > 0) {
        baseProducts = searchResults;
      } else if (filters.length === 0) {
        baseProducts = await dispatch(fetchProductsAll()).unwrap();
      } else {
        baseProducts = await dispatch(fetchProducts(filters)).unwrap();
      }

      // ====== 1) АКЦІЇ (actions) ======
      const snapshotActions = await getDocs(collection(db, "actions"));
      const actions = snapshotActions.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const now = new Date();

      // Підтягнемо всі продукти з БД (для правил підбору)
      const snapshotProducts = await getDocs(collection(db, "product"));
      const allProducts = snapshotProducts.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const actionProducts = allProducts.filter((product) => {
        return actions.some((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = action.endDate ? new Date(action.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const matchProduct = action.appliesTo?.products?.includes(
            product.uid,
          );

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : [];

          const matchSeries = productSeries.some((ser) =>
            action.appliesTo?.series?.includes(ser),
          );

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];

          const actionAuthors = Array.isArray(action.appliesTo?.authors)
            ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });
      });

      const actionProductsWithDiscount = actionProducts.map((product) => {
        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = action.endDate ? new Date(action.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const matchProduct = action.appliesTo?.products?.includes(
            product.uid,
          );

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : [];

          const matchSeries = productSeries.some((ser) =>
            action.appliesTo?.series?.includes(ser),
          );

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];

          const actionAuthors = Array.isArray(action.appliesTo?.authors)
            ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });

        if (matchedAction) {
          return {
            ...product,
            actionDiscountPercent: matchedAction.discountPercent,
          };
        }
        return product;
      });

      // ====== 2) РОЗПРОДАЖІ (sales) ======
      const snapshotSales = await getDocs(collection(db, "sales"));
      const sales = snapshotSales.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const saleMatchedProducts = allProducts.filter((product) => {
        return sales.some((sale) => {
          const start = sale.startDate ? new Date(sale.startDate) : null;
          const end = sale.endDate ? new Date(sale.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const matchProduct = sale.appliesTo?.products?.includes(product.uid);

          // уразі, якщо в товарах іноді series пишеться як seria
          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
              ? [product.seria]
              : Array.isArray(product.series)
                ? product.series
                : typeof product.series === "string" && product.series !== ""
                  ? [product.series]
                  : [];

          const matchSeries = productSeries.some((ser) =>
            sale.appliesTo?.series?.includes(ser),
          );

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
              ? [product.textAutor.split(" ")[0].trim()]
              : [];

          const saleAuthors = Array.isArray(sale.appliesTo?.authors)
            ? sale.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            saleAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });
      });

      const saleProductsWithDiscount = saleMatchedProducts.map((p) => {
        const s = sales.find((sale) => {
          const start = sale.startDate ? new Date(sale.startDate) : null;
          const end = sale.endDate ? new Date(sale.endDate) : null;

          if (end && now > end) return false;
          if (start && now < start) return false;

          const matchProduct = sale.appliesTo?.products?.includes(p.uid);

          const productSeries = Array.isArray(p.seria)
            ? p.seria
            : typeof p.seria === "string" && p.seria !== ""
              ? [p.seria]
              : Array.isArray(p.series)
                ? p.series
                : typeof p.series === "string" && p.series !== ""
                  ? [p.series]
                  : [];

          const matchSeries = productSeries.some((ser) =>
            sale.appliesTo?.series?.includes(ser),
          );

          const productAuthors = Array.isArray(p.textAutor)
            ? p.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof p.textAutor === "string" && p.textAutor !== ""
              ? [p.textAutor.split(" ")[0].trim()]
              : [];

          const saleAuthors = Array.isArray(sale.appliesTo?.authors)
            ? sale.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            saleAuthors.includes(a),
          );

          return matchProduct || matchSeries || matchAuthor;
        });

        if (s) {
          return { ...p, saleDiscountPercent: Number(s.discountPercent) || 0 };
        }
        return p;
      });

      // Мапа для швидкого підкладання знижки у будь-який список
      const saleDiscountMap = new Map(
        saleProductsWithDiscount
          .filter((p) => p.saleDiscountPercent > 0)
          .map((p) => [p.uid || p.id, p.saleDiscountPercent]),
      );

      // ====== 3) Продукти, де поле sale=true (старий флаг для розділу "Акції")
      const saleFlagProducts = await dispatch(
        fetchProducts([{ field: "sale", value: "true" }]),
      ).unwrap();

      // ====== 4) ДЕТЕКТУЄМО АКТИВНІ ФІЛЬТРИ ======
      const hasSaleFilter = filters.some(
        (f) => f.field === "sale" && f.value === "true",
      );
      const hasRozprodazFilter = filters.some(
        (f) => f.field === "rozprodaz" && f.value === "true",
      );

      // ====== 5) Комбінуємо ======
      // Починаємо з базових
      let combined = [...baseProducts];

      // Якщо "Акції" — додаємо товари з actions (pct) і старі "sale=true"
      if (hasSaleFilter) {
        combined = [
          ...combined,
          ...actionProductsWithDiscount.filter(
            (ap) =>
              !combined.some((bp) => (bp.uid || bp.id) === (ap.uid || ap.id)),
          ),
          ...saleFlagProducts.filter(
            (sp) =>
              !combined.some((bp) => (bp.uid || bp.id) === (sp.uid || sp.id)) &&
              !actionProductsWithDiscount.some(
                (ap) => (ap.uid || ap.id) === (sp.uid || sp.id),
              ),
          ),
        ];
      }

      // Якщо "Розпродаж" — додаємо все, що підпало під правила з колекції sales
      if (hasRozprodazFilter) {
        combined = [
          ...combined,
          ...saleProductsWithDiscount.filter(
            (sp) =>
              !combined.some((bp) => (bp.uid || bp.id) === (sp.uid || sp.id)),
          ),
        ];
      }

      // Підкладаємо saleDiscountPercent у будь-які позиції комбінованого (щоб ціни всюди рахувались)
      combined = combined.map((p) => {
        const key = p.uid || p.id;
        const pct = saleDiscountMap.get(key);
        return pct && !Number.isNaN(pct)
          ? { ...p, saleDiscountPercent: pct }
          : p;
      });

      // ====== 6) Сорт ======
      combined.sort((a, b) => {
        const sortA =
          a.sorterNumber && !isNaN(a.sorterNumber)
            ? Number(a.sorterNumber)
            : Infinity;
        const sortB =
          b.sorterNumber && !isNaN(b.sorterNumber)
            ? Number(b.sorterNumber)
            : Infinity;
        return sortA - sortB;
      });

      setProducts(combined);
    };

    fetchData();
  }, [filters, searchResults, dispatch, urlFiltersReady]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleView = () => {
    setChangeVisible((prev) => {
      const newView = !prev;
      localStorage.setItem("catalogView", newView ? "list" : "grid");
      return newView;
    });
  };

  const startIndex = (currentPage - 1) * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const currentProducts = products.slice(startIndex, endIndex);

  const numberOfPages = Math.ceil(products.length / productsPerPage);
  const maxDisplayedPages = 5;
  const firstDisplayedPages = Math.max(
    currentPage - Math.floor(maxDisplayedPages / 2),
    1,
  );
  const lastDisplayedPages = Math.min(
    firstDisplayedPages + maxDisplayedPages - 1,
    numberOfPages,
  );

  const pageNumbers = [];
  for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <Filter filters={filters} />

      <div className={css.wrapCatalogChanges}>
        <p className={css.nameFormatPere}>Змінити формат перегляду</p>
        {changeVisible ? (
          <AiOutlineApartment
            className={css.catalogVisibleCss}
            onClick={toggleView}
          />
        ) : (
          <AiOutlineUnorderedList
            className={css.catalogVisibleCss}
            onClick={toggleView}
          />
        )}
      </div>

      {!changeVisible &&
        currentProducts.map((el) => (
          <CatalogProductComponent
            visitedProducts={visitedProducts}
            setVisitedProducts={setVisitedProducts}
            el={el}
            key={el.id || el.uid}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
        ))}

      {changeVisible && currentProducts.length > 0 && (
        <>
          <SatalogProductComponentsSmall
            visitedProducts={visitedProducts}
            setVisitedProducts={setVisitedProducts}
            el={currentProducts[0]}
            key={currentProducts[0].id || currentProducts[0].uid}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <div className={css.wrapSmallProductTwoType}>
            {currentProducts.slice(1).map((el) => (
              <SmallProductCartTop
                el={el}
                key={el.id || el.uid}
                setCartCounterC={setCartCounterC}
                setLikeCounterC={setLikeCounterC}
              />
            ))}
          </div>
        </>
      )}

      <ListButtonCount
        pageNumbers={pageNumbers}
        handlePageClick={handlePageClick}
        currentPage={currentPage}
      />

      <DiscountAndAction />
      <ViewProductCatalog
        products={productsAll}
        setCartCounterC={setCartCounterC}
        setLikeCounterC={setLikeCounterC}
      />
    </>
  );
}
